import React from 'react';
import { VideoAndShowPDFAfter } from '../../body/VideoSlide';

const NaturalIfThen = () => {
  return (
    <div className='text-left p-4 space-y-6'>
      <VideoAndShowPDFAfter vidSrc={1194426037} />
    </div>
  );
};

export default NaturalIfThen;
